<template>
  <div class="video-scale-wrap" :style="wrapStyle">
    <div class="video-scale" :style="videoStyle">
      <VideoPlayer ref="playerRef" @tagChange="tagChange" />
    </div>
  </div>
</template>
<script>
import VideoPlayer from '@/components/VideoPlayer/index.vue'
export default {
  components: {
    VideoPlayer
  },
  props: {
    // 播放器的宽
    width: {
      type: Number,
      default: 523
    },
    // 播放器的高
    height: {
      type: Number,
      default: 294
    }
  },
  data() {
    return {
      videoList: []
    }
  },
  computed: {
    wrapStyle() {
      const { width, height } = this
      return {
        width: `${width}px`,
        height: `${height}px`
      }
    },
    videoStyle() {
      const { width, height } = this
      const videoHeight = 600
      const scale = height / videoHeight
      if (scale >= 1) {
        return {
          width: '100%',
          height: '100%'
        }
      }
      return {
        height: `${videoHeight}px`,
        width: `${width / scale}px`,
        transform: `scale(${scale})`
      }
    }
  },
  methods: {
    async playerInit({ fragmentList = [], videoList = [] }) {
      if (fragmentList?.length && !fragmentList[0].eventListJs) {
        let currentPos = 0
        fragmentList = fragmentList.map(item => {
          const tempDuration = currentPos
          currentPos += item.duration
          item.position = currentPos

          let eventListJs = []
          if (item.interactiveScriptJs?.length) {
            eventListJs = eventListJs.concat(
              item.interactiveScriptJs
            )
          }
          if (item.endEventJsList?.length) {
            eventListJs = eventListJs.concat(
              item.endEventJsList.map(endItem => ({
                ...endItem,
                position: endItem.overallPosition - tempDuration
              }))
            )
          }
          item.eventListJs = eventListJs
          console.log(videoList.find(video => video.ids?.includes(item.id)))
          // 记录物理片段所属的业务片段
          item.fragmentId = videoList.find(video => video.ids?.includes(item.id)).index
          return item
        })
      }
      console.log(fragmentList, 'fragmentList')
      this.videoList = fragmentList ?? []
      this.$refs.playerRef.initPlayer()
      this.$refs.playerRef.playVideo?.ready(
        {
          list: this.videoList.filter(item => item.fragmentId === 0)
        },
        {
          readyDone: () => {
            this.$refs.playerRef.playVideo.voTagClick(0, {
              autoPlay: false,
              process: 0
            })
          }
        }
      )
    },
    /**
     * 视频片段改变的回调
     */
    tagChange(tag, oldTag) {
      this.$emit('tagChange', tag, oldTag)
    },
    /**
     * 播放
     */
    play() {
      this.$refs.playerRef.play()
    },
    /**
     * 暂停
     */
    pause() {
      this.$refs.playerRef.pause()
    },
    /**
     * 关闭视频
     */
    stop() {
      this.$refs.playerRef.stop()
    },
    /**
     * 改变要播放的视频片段
     * tags: 视频片段数组
     */
    voChangeTags(tags) {
      const ids = tags.map(item => item.index)
      this.$refs.playerRef.interactPlay()
      this.$refs.playerRef.playVideo.voDestroy()
      this.$refs.playerRef.initPlayer()
      this.$refs.playerRef.playVideo?.ready(
        {
          list: this.videoList.filter(item => ids?.includes(item.fragmentId))
        },
        {
          readyDone: () => {
            this.$refs.playerRef.playVideo.voTagClick(0, {
              autoPlay: false,
              process: 0
            })
            this.play()
          }
        }
      )
    }
  }
}
</script>
<style lang="less" scoped>
.video-page {
  position: relative;
}
.video-scale-wrap {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}
.video-scale {
  position: absolute;
  // width: 1066px;
  // height: 600px;
  // transform: scale(324/600);
  transform-origin: top left;
  left: 0;
  top: 0;
}
</style>
